import { useEffect } from "react"
import { useOnMount } from "../../../../../Hooks/useOnMount"
import { useEMRDataProvider } from "../../../../../Providers/EMRDataProvider"
import { useEnvironmentVariablesProvider } from "../../../../../Providers/EnvironmentVariablesProvider"
import { currentPatientFileInfoAtom } from "../Atoms/PatientFile"
import { useRecoilValue } from "recoil"

export const useRefreshEMRData = () => {
    const { isAdmitted, patientIdentifier, mrnError, patientMedications } = useRecoilValue(currentPatientFileInfoAtom)
    const { environmentVariables } = useEnvironmentVariablesProvider()
    const emrDataProvider = useEMRDataProvider()

    // Update once on first render
    useOnMount(() => {
        emrDataProvider.updateEMRData(patientIdentifier, patientMedications.harmonized)
    })

    // Every interval, ask for ALL the medication data again for the current patient
    useEffect(() => {
        if (mrnError || !isAdmitted || !environmentVariables.FEATURE_FLAG_ADT_INTEGRATION) {
            return
        }

        const intervalMilliseconds = 10 * 1000
        
        const intervalId = setInterval(() => {
            emrDataProvider.updatePatientMedications(patientIdentifier)
        }, intervalMilliseconds)

        return () => {
            clearTimeout(intervalId)
        }
    }, [environmentVariables.FEATURE_FLAG_ADT_INTEGRATION, isAdmitted, emrDataProvider, mrnError, patientIdentifier, patientMedications.harmonized])
}
